function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProductWorkplace = function SvgProductWorkplace(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 62 61",
    width: 62,
    height: 61,
    overflow: "hidden",
    ref: svgRef
  }, props), React.createElement("path", {
    style: {
      fillRule: "evenodd",
      stroke: "#002060",
      strokeOpacity: 1,
      fill: "#e9ede4",
      fillOpacity: 1
    },
    strokeMiterlimit: 8,
    stroke: "#5f6321",
    fill: "#81842d",
    d: "m 0.5,31 c 0,-16.845 13.432,-30.5 30,-30.5 16.569,0 30,13.655 30,30.5 0,16.845 -13.431,30.5 -30,30.5 -16.568,0 -30,-13.655 -30,-30.5 z"
  }), React.createElement("g", {
    transform: "translate(0.2987952,-0.2240964)"
  }, React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 38.456068,39.835394 0.09,0.132 c 0.908,0.896 2.163,1.45 3.549,1.45 1.386,0 2.641,-0.554 3.549,-1.45 l 0.09,-0.132 0.737,0.147 c 2.13,0.888 3.624,2.968 3.624,5.392 v 4.907 l -2.594,0.929 c -1.753,0.412 -3.566,0.625 -5.406,0.625 -1.84,0 -3.653,-0.213 -5.406,-0.625 l -2.594,-0.929 v -4.907 c 0,-2.424 1.495,-4.504 3.625,-5.392 z"
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 37.095068,36.835394 c 0,-2.761 2.239,-5 5,-5 2.761,0 5,2.239 5,5 0,2.761 -2.239,5 -5,5 -2.761,0 -5,-2.239 -5,-5 z"
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 23.456068,39.835394 0.09,0.132 c 0.908,0.896 2.163,1.45 3.549,1.45 1.386,0 2.641,-0.554 3.549,-1.45 l 0.09,-0.132 0.737,0.147 c 2.13,0.888 3.624,2.968 3.624,5.392 v 4.907 l -2.594,0.929 c -1.753,0.412 -3.566,0.625 -5.406,0.625 -1.84,0 -3.653,-0.213 -5.406,-0.625 l -2.594,-0.929 v -4.907 c 0,-2.424 1.495,-4.504 3.625,-5.392 z"
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 22.095068,36.835394 c 0,-2.761 2.239,-5 5,-5 2.761,0 5,2.239 5,5 0,2.761 -2.239,5 -5,5 -2.761,0 -5,-2.239 -5,-5 z"
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 30.728068,41.835394 0.096,0.154 c 0.965,1.045 2.299,1.692 3.771,1.692 1.473,0 2.806,-0.647 3.771,-1.692 l 0.096,-0.154 0.782,0.171 c 2.263,1.037 3.851,3.463 3.851,6.292 v 5.724 l -2.756,1.084 c -1.863,0.48 -3.789,0.729 -5.744,0.729 -1.955,0 -3.881,-0.249 -5.744,-0.729 l -2.756,-1.084 v -5.724 c 0,-2.829 1.588,-5.255 3.851,-6.292 z"
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 29.095068,39.335394 c 0,-3.038 2.462,-5.5 5.5,-5.5 3.038,0 5.5,2.462 5.5,5.5 0,3.038 -2.462,5.5 -5.5,5.5 -3.038,0 -5.5,-2.462 -5.5,-5.5 z"
  })), React.createElement("path", {
    d: "m 38.095068,7.835394 v 5.9178 l -1.981,0.19533 c -2.0487,0.41006 -3.8798,1.4042 -5.3036,2.7968 l -0.91945,1.09 -4.7959,-3.5606 1.4419,-1.7094 c 2.618,-2.5607 6.11,-4.2667 10.001,-4.6532 z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1,
      fillOpacity: 1
    }
  }), React.createElement("path", {
    d: "m 38.095068,7.835394 1.4111,0.075358 c 3.6042,0.3870901 6.8391,2.0958 9.2644,4.6606 l 1.3246,1.6978 -4.4428,3.5662 -0.84053,-1.0774 c -1.319,-1.3948 -3.0153,-2.3906 -4.9132,-2.8013 l -1.8035,-0.19227 z",
    style: {
      fill: "#adb9ca",
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1,
      fillOpacity: 1
    }
  }), React.createElement("path", {
    d: "m 50.067068,14.447394 0.34729,0.46877 c 1.5565,2.5659 2.4654,5.659 2.4654,8.9886 0,1.1099 -0.10098,2.1935 -0.29328,3.24 l -0.30074,1.3026 -3.6936,-1.1862 -0.41234,-0.2358 c -0.5195,-0.4721 -0.71836,-1.2642 -0.63358,-2.2013 l -0.02544,-0.0099 0.08233,-0.90939 c 0,-2.1125 -0.57665,-4.0751 -1.5642,-5.703 l -0.15915,-0.21482 z",
    style: {
      fill: "#ecaec6",
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1,
      fillOpacity: 1
    }
  }), React.createElement("path", {
    d: "m 25.075068,14.228394 4.7927,3.5432 -0.17007,0.20077 c -1.1304,1.6296 -1.7904,3.5942 -1.7904,5.7089 l 0.09515,0.91941 -0.0024,8e-4 c 0.09704,0.9381 -0.13059,1.731 -0.72518,2.2036 l -0.43656,0.2183 -4.2907,1.2051 -0.34422,-1.3039 c -0.22008,-1.0476 -0.33568,-2.1323 -0.33568,-3.2433 0,-3.333 1.0403,-6.4293 2.8218,-8.9978 z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1,
      fillOpacity: 1
    }
  }), React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    d: "m 37.004068,24.988394 c -0.217,0.078 -0.404,0.239 -0.513,0.463 -0.213,0.452 -0.027,0.987 0.425,1.197 0.447,0.213 0.988,0.02 1.202,-0.433 0.217,-0.448 0.022,-0.983 -0.425,-1.197 -0.226,-0.105 -0.472,-0.109 -0.689,-0.03 z m 6.578,-12.334 0.029,0.036 0.041,-0.004 -0.017,0.043 0.013,0.026 c 0.118,1.178 -2.935,12.1 -3.838,13.977 -0.716,1.498 -1.701,1.808 -2.659,1.617 l -0.864,-0.296 v 0.008 l -0.039,-0.02 -0.032,-0.012 10e-4,-0.008 -0.778,-0.475 c -0.755,-0.613 -1.136,-1.564 -0.419,-3.062 0.902,-1.877 7.516,-11.125 8.511,-11.782 l 0.034,-0.004 z",
    style: {
      fill: "#ecaec6",
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1,
      fillOpacity: 1
    }
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#002060",
      strokeOpacity: 1,
      fillOpacity: 1
    },
    d: "m 9.045068,37.713394 c -5.536,-4.167 -6.647,-12.033 -2.481,-17.569 1.48,-1.966 3.505,-3.454 5.824,-4.278 l 4.201,11.822 z"
  }), React.createElement("path", {
    style: {
      fill: "#adb9ca",
      fillRule: "evenodd",
      stroke: "#002060",
      strokeOpacity: 1,
      fillOpacity: 1
    },
    d: "m 27.734068,21.926394 c 3.183,6.155 0.772,13.724 -5.383,16.907 -4.282,2.214 -9.455,1.778 -13.307,-1.121 l 7.545,-10.024 z"
  }), React.createElement("path", {
    style: {
      fill: "#ecaec6",
      fillRule: "evenodd",
      stroke: "#002060",
      strokeOpacity: 1,
      fillOpacity: 1
    },
    d: "m 12.422068,15.853394 c 5.919,-2.084 12.468,0.526 15.331,6.109 l -11.164,5.726 z"
  }), React.createElement("g", {
    stroke: "#ffffff",
    fillRule: "evenodd",
    fill: "none",
    transform: "translate(0.59506804,-0.66460595)",
    style: {
      stroke: "#002060",
      strokeOpacity: 1
    }
  }, React.createElement("path", {
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    d: "M 8.423,38.337 15.974,28.305 27.117,22.601",
    style: {
      stroke: "#002060",
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    d: "m 4.172,32.554 c -2.32,-6.529 1.092,-13.703 7.621,-16.023 6.529,-2.321 13.703,1.091 16.023,7.62 2.321,6.529 -1.091,13.703 -7.62,16.024 -6.529,2.32 -13.703,-1.092 -16.024,-7.621 z",
    style: {
      stroke: "#002060",
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    strokeMiterlimit: 8,
    d: "m 11.793,16.531 4.1809,11.775",
    style: {
      stroke: "#002060",
      strokeOpacity: 1
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProductWorkplace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product-workplace.f1bc2b9b.svg";
export { ForwardRef as ReactComponent };